import { createRoute } from '@tanstack/react-router'
import { rootRoute } from './root'
import { StudioPage } from '../features/studio/page'

export const trainerRoute = createRoute({
  path: 'trainer',
  getParentRoute: () => rootRoute,
  component: StudioPage,
})
